export default {
  USER: "User",
  USER_STEPS: "UserSteps",

  AUTHOR: "Author",
  USER_PRESETS: "UserPresets",
  PLAN: "Plans",
  USER_PLANS: "UserPlans",
  PLAN_CATEGORIES: "PlanCategory",
  PLAN_DAY: "DayPlans",
  PLAN_STEP: "Steps",
  IMAGES: "Images",
  COMMUNITY: "Community",
  // Per-community marketing/brand context (positioning, ICP, content angles,
  // tone rules). Subcollection Community/{id}/Marketing/context. Written by the
  // MCP content tools and by the Settings > Brand tab; both share this one doc.
  MARKETING: "Marketing",
  ADMIN_USER: "AdminUser",
  NOTIFICATION: "Notification",
  EVENT_CATEGORY: "EventCategory",
  EVENT: "Event",
  COMMUNITY_ROUNDTABLE: "CommunityRoundtable",
  EMAIL_CAMPAIGN: "EmailCampaign",
  AUDIO: "Audio",
  VIDEO: "Video",
  REEL_CREATOR_CONFIG: "ReelCreatorConfig",
  COMMUNITY_MEDIA: "CommunityMedia",
  MEDIA_PROJECT: "MediaProjects",
  REEL_CHARACTER: "ReelCharacters",
  AD_VARIANTS: "AdVariants",
  QUOTE: "Quote",
  SKILLS: "Skills",
  HABIT: "Habits",
  HABIT_ACTION: "Actions",
  HABIT_SUBACTION: "Subactions",
  HABIT_ACTION_LINK: "HabitAction",
  ACTION_SUBACTION_LINK: "ActionSubaction",

  QUESTION: "Questions",
  ONBOARDING: "OnboardingQuestionnaire",

  ACTION_TRACKING: "ActionTracking",
  ANALYTICS: "Analytics",
  LEARNING_PLAN_EXPERIMENT_AGENT: "LearningPlanExperimentAgent",
  LEARNING_PLAN_EXPERIMENT_QUEUE: "queue",
  LEARNING_PLAN_HEALTH: "LearningPlanHealth",
  LEARNING_PLAN_EXPERIMENT_HISTORY: "LearningPlanExperimentHistory",
  LANDING_PAGE: "landingPage",
  DISTRIBUTION: "Distribution",
  DISTRIBUTION_HISTORY: "History",

  // Global platform issue board: Board/global (stage config) with Cards and
  // per-card Comments subcollections. Shared across all communities.
  BOARD: "Board",
  BOARD_CARDS: "Cards",
  BOARD_COMMENTS: "Comments",

  // Internal app portfolio pipeline: AppPipeline/global (stage config) with a
  // Cards subcollection keyed by communityId. Operator-only.
  APP_PIPELINE: "AppPipeline",
  APP_PIPELINE_CARDS: "Cards",
};
